import { NgModule } from '@angular/core';

import { DialogOutletDirective } from './dialog-outlet.directive';
import { stripChildrenOutlets, keepChildrenOutlets } from './url-tree-utils';

@NgModule({
  declarations: [DialogOutletDirective],
  exports: [DialogOutletDirective],
})
export class DialogOutletModule {}

export { DialogOutletDirective, stripChildrenOutlets, keepChildrenOutlets };
